import React from 'react';
import { OpenAlertPayload } from 'state/providers/AlertProvider';
import { Snackbar, Alert, AlertTitle } from '@mui/material';
type BaseAlertProps = {
  unmountOnClose?: boolean;
} & OpenAlertPayload;

export const BaseAlert: React.FC<BaseAlertProps> = ({
  variant,
  styleVariant,
  open,
  title,
  body,
  options,
  onClose,
  ...providerOpts
}) => {
  return providerOpts.unmountOnClose && !open ? (
    <div />
  ) : (
    <Snackbar
      open={open}
      autoHideDuration={providerOpts.forceClose ? undefined : options?.duration}
      onClose={onClose}
      anchorOrigin={options?.location as any}
    >
      <Alert
        onClose={onClose}
        severity={variant}
        variant={styleVariant}
        classes={{
          message: options?.classes?.messageClass,
          icon: options?.classes?.iconClass
        }}
      >
        {title && <AlertTitle className={options?.classes?.titleClass}>{title}</AlertTitle>}
        {body}
      </Alert>
    </Snackbar>
  );
};
